






































































































import { UserStaffParams } from '@/store/interfaces/staffUser';
import userStaffType from '@/store/types/userStaff';
import auth from '@/store/types/auth';
import copyObj from '@/util/copyObj';
import { NemiPayNotifications } from '@/util/nemiPayNotifications';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import IntermediarySelect from '../Reusable/IntermediarySelect.vue';

export default Vue.extend({
  name: 'ProfileStaffComponent',
  components: { IntermediarySelect, },
  data: () => ({
    user: {
      profile: {
        first_name: '',
        last_name: '',
      },
      intermediary: null,
      email: '',
      intermediary_id: '',
    } as UserStaffParams,
    originalUser: null as UserStaffParams | null,
    edit: false,
    user_id: '',
  }),
  computed: {
    ...mapGetters({
      userStaff: `userStaff/${userStaffType.getters.GET_SINGLE_USER_STAFF}`,
      currentUser: `authModule/${auth.getters.GET_AUTH_USER}`,
    }),
    // Determinar qué datos usar según la ruta
    userData(): UserStaffParams {
      if (this.$route.name === 'my-profile') {
        return this.currentUser as UserStaffParams;
      }
      return this.userStaff as UserStaffParams;
    },
  },
  mounted() {
    this.loadUserData();
  },
  watch: {
    // Observar cambios en los datos del usuario
    userData: {
      handler() {
        this.loadUserData();
      },
      deep: true,
    },
    // Observar cambios de ruta
    '$route.name'() {
      this.loadUserData();
    },
  },
  methods: {
    ...mapActions({
      updateUserStaff: `userStaff/${userStaffType.actions.UPDATE_USER_STAFF}`,
    }),
    loadUserData() {
      if (!this.userData || !this.userData.id) {
        return;
      }
      
      this.user_id = this.userData.id;
      this.user = copyObj({
        ...this.userData,
        intermediary_id: this.userData.intermediary
          ? this.userData.intermediary.id
          : '',
      });
      this.edit = false;
      this.originalUser = null;
    },
    startEdit() {
      this.originalUser = copyObj(this.user);
      this.edit = true;
    },
    cancelEdit() {
      if (this.originalUser) {
        this.user = copyObj(this.originalUser);
      }
      this.edit = false;
    },
    async updateProfile() {
      const notification = new NemiPayNotifications();
      
      if (this.$route.name === 'my-profile') {
        // Para mi perfil, enviar con el formato específico requerido
        const myProfileData = {
          id: this.$data.user_id,
          email: this.$data.user.email,
          intermediary_id: this.$data.user.intermediary_id || '',
          profile: {
            id: this.$data.user.profile.id,
            first_name: this.$data.user.profile.first_name,
            last_name: this.$data.user.profile.last_name,
          },
          intermediary: this.$data.user.intermediary,
        };
        this.$emit('currentUser', myProfileData);
        this.$data.edit = false;
      } else {
        // Para staff users, enviar el objeto completo como antes
        const newData = this.$data.user;
        delete newData.permission_groups;
        const dataToSend = {
          user_id: this.$data.user_id,
          data: newData,
        };
        this.updateUserStaff(dataToSend)
          .then(() => {
            notification.success('Actualizado correctamente');
            this.$data.edit = false;
          })
          .catch(() => {
            notification.warning('No hemos podido actualizar el perfil :(');
          });
      }
    },
  },
});
